// extracted by mini-css-extract-plugin
export default {"grid":"Faq_grid__i1g5Z","intro":"Faq_intro__iWvXs","buttons":"Faq_buttons__gSq+N","list":"Faq_list__W6-YL","item":"Faq_item__VcZkc","icon":"Faq_icon__eg72v"};